export default __webpack_public_path__ + "static/media/before@2x.3bc5911d.png";